import React, { useCallback, useEffect, useState } from "react";
import { Input, Button, Spin } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import DOMPurify from "dompurify";
import Service from "../../service";

/**
 * Server-generated image captcha. `refreshKey` forces a new image (used after
 * a rejected submit, since every captcha is single-use).
 */
const CaptchaField = ({ companyslug, value, onChange, refreshKey = 0 }) => {
  const [svg, setSvg] = useState("");
  const [loading, setLoading] = useState(false);
  const [failed, setFailed] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    setFailed(false);
    try {
      const response = await Service.makeAPICall({ methodName: Service.getMethod, api_url: Service.publicCaptcha(companyslug) });
      if (response?.data?.status === 200 && response.data.data?.svg) {
        setSvg(DOMPurify.sanitize(response.data.data.svg, { USE_PROFILES: { svg: true, svgFilters: true } }));
        onChange({ token: response.data.data.captcha_token, text: "" });
      } else {
        setFailed(true);
      }
    } catch (error) {
      setFailed(true);
    } finally {
      setLoading(false);
    }
  }, [companyslug, onChange]);

  useEffect(() => {
    load();
  }, [load, refreshKey]);

  return (
    <div className="career-captcha">
      <div className="career-captcha-image">
        {loading ? <Spin size="small" /> : failed ? <span className="career-muted">Could not load</span> : <div dangerouslySetInnerHTML={{ __html: svg }} />}
      </div>
      <Button type="text" icon={<ReloadOutlined />} onClick={load} aria-label="Get a new captcha" />
      <Input
        placeholder="Enter the characters shown"
        value={value?.text || ""}
        onChange={(event) => onChange({ token: value?.token, text: event.target.value })}
        maxLength={10}
        autoComplete="off"
      />
    </div>
  );
};

export default CaptchaField;
